export default {
  FETCHED_ALL: 'FETCHED_ALL_PARTITIONS',
  FETCHED_MULTIPLE: 'FETCHED_PARTITIONS',
  FETCHED_SINGLE: 'FETCHED_PARTITION',
};
